import { Box } from "@material-ui/core";
import { ActionLink } from "halifax";
import React, { useEffect, useState } from "react";
import { Airport, FareDetails, TripDetails } from "redmond";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CHANGE_TEXT,
  CHANGE_OUTBOUND_FLIGHT_TEXT,
  CHANGE_RETURN_FLIGHT_TEXT,
  VIEW_DETAILS_TEXT,
  VIEW_OUTBOUND_FLIGHT_DETAILS_TEXT,
  VIEW_RETURN_FLIGHT_DETAILS_TEXT,
} from "../../constants";
import { DesktopFlightReviewDetailsPopover } from "../DesktopFlightReviewDetailsPopover";
import { getIsMixedClass } from "../../../../constants";

interface IFlightReviewDetailsPopoverProps {
  departure: boolean;
  tripDetails: TripDetails;
  fareDetails: FareDetails;
  isMobile: boolean;
  onClickEdit?: () => void;
  airports: { [key: string]: Airport };
  // isSeatsUXOptimizationExperiment?: boolean;
  // isVITripSelected: boolean;
  // setOpenVIVariantModal: (variant: IVirtualInterliningVariant) => void;
  // setOpenMultipleAirlinesFares: (value: boolean) => void;
  disableChangeFlight: boolean;
}

const popoverDefaultProps: Partial<IFlightReviewDetailsPopoverProps> = {
  onClickEdit: undefined,
};

export const FlightReviewDetailsPopover = (
  props: IFlightReviewDetailsPopoverProps
) => {
  const {
    departure,
    tripDetails,
    fareDetails,
    isMobile,
    onClickEdit,
    airports,
    // isSeatsUXOptimizationExperiment,
    // isVITripSelected,
    // setOpenVIVariantModal,
    // setOpenMultipleAirlinesFares,
    disableChangeFlight,
  } = props;

  const [openPopover, setOpenPopover] = useState<boolean>(false);
  const [isMixedCabinClass, setIsMixedCabinClass] = useState(false);

  useEffect(() => {
    if (fareDetails) {
      if (departure) {
        setIsMixedCabinClass(getIsMixedClass(fareDetails.slices[0]));
      } else {
        setIsMixedCabinClass(getIsMixedClass(fareDetails.slices[1]));
      }
    }
  }, [departure, fareDetails]);

  // const tripDetailsSlice = tripDetails.slices[departure ? 0 : 1];

  return (
    <Box className="pkg-review-flight-summary-panel-flight-review-details-root">
      <Box className="flight-summary-panel-flight-review-details-container">
        {isMobile && (
          <FontAwesomeIcon
            className="mobile-right-chevron"
            onClick={() => setOpenPopover(true)}
            icon={faChevronRight}
            aria-label={departure ? VIEW_OUTBOUND_FLIGHT_DETAILS_TEXT : VIEW_RETURN_FLIGHT_DETAILS_TEXT}
            role="button"
          />
        )}
        {!isMobile && (
          <>
            <ActionLink
              className="open-popover-button"
              onClick={() => setOpenPopover(true)}
              content={VIEW_DETAILS_TEXT}
              label={departure ? VIEW_OUTBOUND_FLIGHT_DETAILS_TEXT : VIEW_RETURN_FLIGHT_DETAILS_TEXT}
            />
            {!disableChangeFlight && onClickEdit && (
              <ActionLink
                className="edit-flights-button"
                onClick={onClickEdit}
                content={CHANGE_TEXT}
                label={departure ? CHANGE_OUTBOUND_FLIGHT_TEXT : CHANGE_RETURN_FLIGHT_TEXT}
              />
            )}
          </>
        )}
        {!isMobile && (
          <DesktopFlightReviewDetailsPopover
            departure={departure}
            tripDetails={tripDetails}
            fareDetails={fareDetails}
            openPopover={openPopover}
            onClose={() => setOpenPopover(false)}
            onClickEdit={onClickEdit}
            airports={airports}
            isMixedCabinClass={isMixedCabinClass}
            disableChangeFlight={disableChangeFlight}
          />
        )}
      </Box>
    </Box>
  );
};

FlightReviewDetailsPopover.defaultProps = popoverDefaultProps;
